<button class="btn btn-success btn-sm"
        (click)="searchCsvExport()"
        *ngIf="showExport">
  <bi name="download"></bi>
  Download CSV
</button>
